import React from 'react';
import { services } from '../../data/services';
import ServiceSection from '../../components/ServiceSection';
import Hero from '../../components/Hero';

const Supraveghere = () => {
  const supraveghereService = services.find(service => service.title === "Supraveghere Video");

  return (
    <>
      <Hero
        title="Supraveghere Video"
        subtitle="Sisteme profesionale de supraveghere pentru siguranța casei tale"
        variant="compact"
        ctaLabel="Vezi Tarife"
        ctaHref="#tarife"
        backgroundImageUrl="/img/hero-supraveghere.jpg"
        icon={supraveghereService?.icon}
        iconLabel={supraveghereService?.title}
      />

      {supraveghereService && (
        <ServiceSection
          service={supraveghereService}
          index={0}
          pricingFirst
          id="tarife"
          backgroundImage={false}
          showTitleBlock={false}
        />
      )}
    </>
  );
};

export default Supraveghere;
